/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import {
  AmountDecimal,
  AmountDecimal$inboundSchema,
  AmountDecimal$Outbound,
  AmountDecimal$outboundSchema,
} from "./amountdecimal.js";

/**
 * Represents a modifier or option applied to a scheduled transfer line item.
 */
export type CreateScheduledTransferLineItemOption = {
  /**
   * The name of the option or modifier.
   */
  name: string;
  /**
   * The quantity of this option.
   */
  quantity: number;
  /**
   * Optional price modification applied by this option. Can be positive, negative, or zero.
   */
  priceModifier?: AmountDecimal | undefined;
  /**
   * Optional group identifier to categorize related options (e.g., 'toppings').
   */
  group?: string | undefined;
  /**
   * Optional list of images associated with this line item.
   */
  imageIDs?: Array<string> | undefined;
};

/** @internal */
export const CreateScheduledTransferLineItemOption$inboundSchema: z.ZodType<
  CreateScheduledTransferLineItemOption,
  z.ZodTypeDef,
  unknown
> = z.object({
  name: z.string(),
  quantity: z.number().int(),
  priceModifier: AmountDecimal$inboundSchema.optional(),
  group: z.string().optional(),
  imageIDs: z.array(z.string()).optional(),
});
/** @internal */
export type CreateScheduledTransferLineItemOption$Outbound = {
  name: string;
  quantity: number;
  priceModifier?: AmountDecimal$Outbound | undefined;
  group?: string | undefined;
  imageIDs?: Array<string> | undefined;
};

/** @internal */
export const CreateScheduledTransferLineItemOption$outboundSchema: z.ZodType<
  CreateScheduledTransferLineItemOption$Outbound,
  z.ZodTypeDef,
  CreateScheduledTransferLineItemOption
> = z.object({
  name: z.string(),
  quantity: z.number().int(),
  priceModifier: AmountDecimal$outboundSchema.optional(),
  group: z.string().optional(),
  imageIDs: z.array(z.string()).optional(),
});

export function createScheduledTransferLineItemOptionToJSON(
  createScheduledTransferLineItemOption: CreateScheduledTransferLineItemOption,
): string {
  return JSON.stringify(
    CreateScheduledTransferLineItemOption$outboundSchema.parse(
      createScheduledTransferLineItemOption,
    ),
  );
}
export function createScheduledTransferLineItemOptionFromJSON(
  jsonString: string,
): SafeParseResult<CreateScheduledTransferLineItemOption, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) =>
      CreateScheduledTransferLineItemOption$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'CreateScheduledTransferLineItemOption' from JSON`,
  );
}
